// extracted by mini-css-extract-plugin
export default {"message":"MessageBox_message__LUPaD","message__title":"MessageBox_message__title__-wWND","message__toolbar":"MessageBox_message__toolbar__GiXLl"};